var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-group" },
    [
      _vm.showRemoveButton
        ? _c("div", { staticClass: "control-buttons" }, [
            _c(
              "div",
              { staticClass: "control-button" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-icon-button md-mini",
                    on: {
                      click: function () {
                        return _vm.onRemoved(_vm.clone.id)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("delete_outline")])],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.clone.filters, function (filter, index) {
        return _c("SingleFilter", {
          key: filter.id,
          attrs: {
            "enable-operator-changed": _vm.clone.filters.length > 1,
            operator: _vm.clone.operator,
            "on-operator-changed": _vm.onOperatorChanged,
            selected: filter.id === _vm.selectedFilterId,
            "on-selected": function () {
              return (_vm.selectedFilterId = filter.id)
            },
            "on-canceled": function () {
              return (_vm.selectedFilterId = null)
            },
            "on-removed": _vm.onFilterRemoved,
            "group-id": _vm.value.id,
            "on-group-select-hovered": function (hovered) {
              return (_vm.groupSelectHovered = hovered)
            },
            "group-select-hovered": _vm.groupSelectHovered,
          },
          model: {
            value: _vm.clone.filters[index],
            callback: function ($$v) {
              _vm.$set(_vm.clone.filters, index, $$v)
            },
            expression: "clone.filters[index]",
          },
        })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-row",
          class: { empty: !_vm.clone.filters.length },
        },
        [
          _c(
            "a-popover",
            {
              attrs: {
                trigger: "click",
                placement: "left",
                overlayClassName: "no-padding",
              },
              model: {
                value: _vm.attributePickerVisible,
                callback: function ($$v) {
                  _vm.attributePickerVisible = $$v
                },
                expression: "attributePickerVisible",
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "content" }, slot: "content" },
                [
                  _c("AttributePicker", {
                    attrs: {
                      "default-selected": null,
                      pick: _vm.onAttributePicked,
                      "filter-mode": true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "add-filter-button" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" add "),
                ]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.addNewFilter")) +
                    "\n            "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }